import type {ErrorMessage} from 'angular-error-repository';

export const MinError: ErrorMessage = () => {
    return `Error.Min`;
};
